import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Lock, Check, ArrowRight } from "lucide-react";

export default function LimitPage() {
  const { t } = useLang();
  return (
    <div className="App min-h-screen flex flex-col" data-testid="limit-page">
      <Header variant="public" />
      <main className="flex-1 brand-mesh">
        <div className="grid-paper absolute inset-0 pointer-events-none" />
        <div className="relative max-w-[1000px] mx-auto px-6 md:px-10 py-20 md:py-28">
          <div className="text-center max-w-2xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary mb-6">
              <Lock className="w-7 h-7" strokeWidth={1.6} />
            </div>
            <p className="eyebrow mb-3">{t("limit.badge")}</p>
            <h1 className="text-4xl md:text-5xl tracking-tight mb-5" data-testid="limit-title">{t("limit.title")}</h1>
            <p className="text-muted-foreground leading-relaxed text-lg">{t("limit.sub")}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mt-14">
            <PlanCard
              testid="limit-plan-scan"
              title={t("pricing.paid")}
              price={t("pricing.paid.price")}
              desc={t("pricing.paid.d")}
              cta={t("limit.cta.register")}
            />
            <PlanCard
              testid="limit-plan-sub"
              highlight
              title={t("pricing.sub")}
              price={t("pricing.sub.price")}
              desc={t("pricing.sub.d")}
              cta={t("limit.cta.register")}
            />
          </div>
          <p className="text-center text-xs text-muted-foreground mt-8 font-mono">{t("limit.foot")}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function PlanCard({ title, price, desc, cta, highlight, testid }) {
  return (
    <div data-testid={testid}
      className={`rounded-2xl p-8 border transition-transform hover:-translate-y-1 ${highlight ? "border-primary bg-white shadow-[0_20px_50px_-20px_rgba(31,90,153,0.4)]" : "border-border bg-white/90"}`}>
      <h3 className="font-serif text-2xl mb-1">{title}</h3>
      <p className="text-3xl font-serif text-primary mb-4">{price}</p>
      <ul className="space-y-2 mb-7">
        {desc.split(" · ").map((s) => (
          <li key={s} className="flex gap-2 text-sm text-muted-foreground"><Check className="w-4 h-4 text-secondary shrink-0 mt-0.5" /> {s}</li>
        ))}
      </ul>
      <Link to="/register">
        <Button className={`w-full h-12 rounded-lg font-semibold ${highlight ? "bg-primary text-primary-foreground hover:bg-primary/90" : "bg-foreground text-white hover:bg-foreground/90"}`} data-testid={`${testid}-cta`}>
          {cta} <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </Link>
    </div>
  );
}
